import { Component, Input } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { PaymentMethod } from 'src/app/services/payment/methods/methods.models';
import { MatDialog } from '@angular/material/dialog';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-payment-method-selector',
  templateUrl: './payment-method-selector.component.html',
  styleUrls: ['./payment-method-selector.component.scss']
})
export class PaymentMethodSelectorComponent extends BasePageComponent {



  _selectedPayment: PaymentMethod;
  @Input()
  set selectedPayment(paymentMethod: PaymentMethod) {
    this._selectedPayment = paymentMethod;
  }

  get selectedPayment() {
    return this._selectedPayment;
  }


  constructor(
    public paymentSelectSheet: MatDialog,
    private detectDesktopService: DetectDeviceService,
    protected licenceService: LicenceService

  ) { super() }


  ngOnInit(): void {
    this.isDesktop = this.detectDesktopService.isDesktop();
  }



}
